import React from 'react'
import PropTypes from 'prop-types'
import Svg from './svg'

export default function SvgSprite ({ sprite, item, ...props }) {
  return (
    <Svg href={`${sprite}#${item}`} {...props}/>
  )
}

SvgSprite.propTypes = {
  sprite: PropTypes.string.isRequired,
  item: PropTypes.string.isRequired
}
